import { scrollToElement } from './scrollToElement';

// eslint-disable-next-line no-undef
const $ = jQuery;

class GravityFormsCustomizations {
	constructor() {
		this.initialized = false;
		this.handlePostRender = this.handlePostRender.bind(this);
		this.handleConfirmationLoaded =
			this.handleConfirmationLoaded.bind(this);
		this.handlePageLoaded = this.handlePageLoaded.bind(this);
		this.handleProgressHideClick = this.handleProgressHideClick.bind(this);
		this.setDatepickerOptions = this.setDatepickerOptions.bind(this);
	}

	init() {
		if (this.initialized) {
			return;
		}

		this.bindListeners();

		this.initialized = true;
	}

	bindListeners() {
		$(document).on('gform_post_render', this.handlePostRender);
		$(document).on(
			'gform_confirmation_loaded',
			this.handleConfirmationLoaded
		);
		$(document).on('gform_page_loaded', this.handlePageLoaded);
		$(document).on(
			'click',
			'.gform_next_button, .gform_previous_button, .gform_button[type="submit"]',
			this.handleProgressHideClick
		);
	}

	handlePostRender(event, formId) {
		const dropAreas = document.querySelectorAll(
			`#gform_wrapper_${formId} .gform_drop_area`
		);

		dropAreas.forEach((area) => this.toggleDropActiveClass(area));

		gform.addFilter(
			'gform_datepicker_options_pre_init',
			this.setDatepickerOptions
		);

		const hasError =
			document.querySelector(
				`#gform_wrapper_${formId}.gform_validation_error`
			) !== null;

		if (hasError) {
			scrollToElement(document.querySelector(`#gform_wrapper_${formId}`));
		}
	}

	handleConfirmationLoaded(event, formId) {
		const intro = document.querySelector('.tht-form-intro');

		if (intro) {
			intro.remove();
		}

		scrollToElement(
			document.querySelector(`#gform_confirmation_wrapper_${formId}`)
		);
	}

	handlePageLoaded(event, formId) {
		const hasError =
			document.querySelector(
				`#gform_wrapper_${formId}.gform_validation_error`
			) !== null;

		if (!hasError) {
			scrollToElement(
				document.querySelector(`#gform_wrapper_${formId}`),
				'instant'
			);
		}
	}

	handleProgressHideClick(event) {
		const formWrapper = event.target.closest('.gform_wrapper');

		if (!formWrapper) {
			return;
		}

		const pageSteps = formWrapper.querySelector('.gf_page_steps');

		if (pageSteps) {
			pageSteps.style.display = 'none';
		}
	}

	toggleDropActiveClass(dropArea) {
		const dropActiveClass = 'tht-drop-active';

		dropArea.addEventListener('dragover', () =>
			dropArea.classList.add(dropActiveClass)
		);
		dropArea.addEventListener('dragleave', () =>
			dropArea.classList.remove(dropActiveClass)
		);
		dropArea.addEventListener('drop', () =>
			dropArea.classList.remove(dropActiveClass)
		);
	}

	setDatepickerOptions(optionsObj, formId, fieldId, $input) {
		const $field = $input.closest('.gfield');

		$input.prop('readonly', true).attr('autocomplete', 'off');

		if (!$field.hasClass('tht-datepicker-no-past-dates')) {
			return optionsObj;
		}

		optionsObj.minDate = 0;
		optionsObj.maxDate = new Date(new Date().getFullYear() + 4, 11, 31); // 31. Dezember in vier Jahren
		this.translateDatepicker(optionsObj);

		return optionsObj;
	}

	translateDatepicker(optionsObj) {
		const locale = document.documentElement.lang || 'de-DE';

		optionsObj.monthNames = Array.from({ length: 12 }, (_, month) =>
			new Intl.DateTimeFormat(locale, { month: 'long' }).format(
				new Date(2026, month, 1)
			)
		);

		optionsObj.dayNames = Array.from({ length: 7 }, (_, day) =>
			new Intl.DateTimeFormat(locale, { weekday: 'long' }).format(
				new Date(2026, 0, 4 + day)
			)
		);
	}
}

export const gravityFormsCustomizations = new GravityFormsCustomizations();
